import GSAP from 'gsap';
import each from 'lodash/each';
import Page from '@averyano/core/src/classes/Page';
import MarqComponent from '../../components/MarqComponent'; // import Lightbox from '../../components/Lightbox';
export default class StorePage extends Page {
	constructor(el) {
		super({
			element: el,
			elements: {
				imageFigures: '.store__item',
				marq: '.marq',
				marqStack: '.marq__stack',
			},
		});

		this.id = 'store';
		this.isCreated = false;
		this.isDragging = false;
		// this.lightbox = new Lightbox();
	}

	create() {
		if (this.template != this.id) return;
		if (!this.isReady) super.createComponent();
		if (!this.isCreated) {
			this.components = {
				marq: new MarqComponent({
					element: '.marq',
					html: `<div class="marq__stack"><span>${
						FRONTJS[window.locale].freeshipping
					}</span><svg class="marq__svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M24,12c-9.19,0-12,2.81-12,12,0-9.19-2.81-12-12-12,9.19,0,12-2.81,12-12,0,9.19,2.81,12,12,12Z" fill="rgb(var(--data-color-white))"></path></svg></div>`,
				}),
				// cover: new CoverSection(),
				// exhibition: new ExhibitionSection(),
				// donation: new DonationSection(),
				// campaign: new CampaignSection(),
			};
			this.isCreated = true;
		}
		console.log('🔼 Create Store Page');

		super.create();

		// this.lightbox.create(this.elements.imageFigures);
		this.addEventListeners();

		each(this.components, (component) => {
			if (component.createComponent) component.createComponent();
		});

		// window.$ga.trackEvent('Page View', {
		// 	action: 'Visit',
		// 	label: '/' + this.id,
		// });
		console.log(this.id);
		console.log(`🔼 ${this.id} is created`);
	}
	// openLightbox(item, type = 'image') {
	// 	console.log('Open Lightbox', this.isDragging);
	// 	if (this.isDragging) return;
	// 	this.lightbox.setActiveImage(item, type);
	// 	this.lightbox.open();
	// }

	onResize() {
		each(this.components, (component) => {
			if (component.onResize) component.onResize();
		});
		// this.lightbox.onResize();
	}

	destroy() {
		super.destroy();
	}

	show() {
		// if (this.template != this.id) return;

		console.log('🔼 Show Store Page');
		console.log(this.components);
		// each(this.components, (component) => {
		// 	console.log(component);
		// 	if (component.show) component.show();
		// });

		GSAP.to(this.element, {
			autoAlpha: 1,
			duration: 1.5,
			ease: 'power2.out',
		});
		window.scrollTo(0, 0);
		// this.$emit('navChangeIndex', 3);
	}

	hide() {
		return new Promise((resolve) => {
			GSAP.to(this.element, {
				autoAlpha: 0,
				duration: 0.5,
				onComplete: resolve,
			});
		});
	}

	addEventListeners() {
		each(this.components, (component) => {
			if (component.addEventListeners) component.addEventListeners();
		});
		// this.lightbox.addEventListeners();
		// console.log('hello?');
		// each(this.elements.imageFigures, (item) => {
		// 	item.addEventListener('click', () => {
		// 		this.openLightbox(item);
		// 	});
		// });
	}

	removeEventListeners() {
		// each(this.elements.imageFigures, (item) => {
		// 	item.removeEventListener('click', () => {
		// 		this.openLightbox(item);
		// 	});
		// });
	}
}
